import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './not-found.module.css';
import { Button } from '../../components';
import notFound from '../../assets/not-found.png';
import { useTranslation } from 'react-i18next';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <img
        src={notFound}
        alt="404 Not Found"
        className={styles.image}
      />
      <Button onClick={handleBackToHome}>{t('backHome')}</Button>
    </div>
  );
};
